import * as React from 'react';

import { cn } from '@/utils/styles';

export const DialogFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2', className)} {...props} />
);

DialogFooter.displayName = 'DialogFooter';
